import { RELATIONSHIP_LENSES, type RelationshipLens } from '../data/graph-types.js';

type LensControlProps = {
  counts: Readonly<Record<RelationshipLens, number>>;
  enabled: readonly RelationshipLens[];
  onToggle: (lens: RelationshipLens) => void;
};

const LENS_COPY: Readonly<Record<RelationshipLens, { label: string; description: string }>> = {
  personal: {
    label: 'Personal',
    description: 'Spouse and partner connections from the current snapshot.',
  },
  family: {
    label: 'Family',
    description: 'Parent, child, stepparent, sibling, relative, and godparent connections.',
  },
};

export function LensControl({ counts, enabled, onToggle }: LensControlProps) {
  return (
    <fieldset className="lens-control">
      <legend className="sr-only">Enabled relationship lenses</legend>
      {RELATIONSHIP_LENSES.map((lens) => {
        const active = enabled.includes(lens);
        const isOnlyEnabledLens = active && enabled.length === 1;
        const copy = LENS_COPY[lens];
        return (
          <button
            key={lens}
            type="button"
            className={`lens-control__button lens-control__button--${lens}`}
            aria-pressed={active}
            aria-label={`${copy.label} lens, ${counts[lens].toLocaleString('en-US')} connections. ${copy.description}`}
            disabled={isOnlyEnabledLens}
            title={
              isOnlyEnabledLens
                ? 'At least one relationship lens must remain enabled.'
                : copy.description
            }
            onClick={() => onToggle(lens)}
          >
            <span className="lens-control__line" aria-hidden="true" />
            <span>{copy.label}</span>
            <small>{counts[lens].toLocaleString('en-US')}</small>
          </button>
        );
      })}
    </fieldset>
  );
}
